import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import {
  Table,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import {
  getDisposal as onGetDisposals,
  addNewDisposal as onAddNewDisposal,
  updateDisposal as onUpdateDisposal,
  deleteDisposal as onDeleteDisposal,
  getDisposalLoading,
} from "../../../store/disposal/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

const Disposal = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const { disposals, isDisposalCreated, isDisposalSuccess, loading, error } =
    useSelector((state) => ({
      disposals: state.Disposal.disposals,
      isDisposalCreated: state.Disposal.isDisposalCreated,
      isDisposalSuccess: state.Disposal.isDisposalSuccess,
      loading: state.Disposal.loading,
      error: state.Disposal.error,
    }));

  const [disposalList, setDisposalList] = useState([]);
  const [disposal, setDisposal] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  const onClickDelete = (disposal) => {
    setDisposal(disposal);
    setDeleteModal(true);
  };

  const handleDeleteDisposal = () => {
    if (disposal) {
      dispatch(onDeleteDisposal(disposal));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setDisposalList(disposals);
  }, [disposals]);

  useEffect(() => {
    if (!isEmpty(disposals)) setDisposalList(disposals);
  }, [disposals]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredDisposals = disposals;
      if (type !== "all") {
        filteredDisposals = disposals.filter(
          (disposal) => disposal.disposal_status.name === type
        );
      }
      setDisposalList(filteredDisposals);
    }
  };

  useEffect(() => {
    if (disposals && !disposals.length && !isSearch) {
      dispatch(onGetDisposals());
    }
    setIsSearch(true);
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (
      obj.data &&
      obj?.data?.user?.user_position &&
      obj?.data?.user?.user_position?.position_role
    )
      setRoles(obj?.data?.user?.user_position?.position_role.method);
    else setRoles(null);

    if (obj?.data)
      setUserType(obj?.data?.userType);
  }, [dispatch, disposals, isSearch]);

  useEffect(() => {
    setDisposal(disposals);
  }, [disposals]);

  useEffect(() => {
    if (!isEmpty(disposals)) {
      setDisposal(disposals);
      setIsEdit(false);
    }
  }, [disposals]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setDisposal(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleDisposalClick = useCallback(
    (arg) => {
      const disposal = arg;
      setDisposal({
        id: disposal.id,
        disposal_name: disposal.disposal_name,
        subscribedat: disposal.subscribedat,
        expiredat: disposal.expiredat,
        description: disposal.description,
        disposal_status: disposal.disposal_status.id,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      disposal_name: (disposal && disposal.disposal_name) ?? "",
      subscribedat: (disposal && disposal.subscribedat) ?? "",
      expiredat: (disposal && disposal.expiredat) ?? "",
      status: (disposal && disposal.disposal_status) || "1",
      description: (disposal && disposal.description) ?? "",
    },
    validationSchema: Yup.object({
      disposal_name: Yup.string().required("Please Enter Disposal Name"),
      subscribedat: Yup.string().required("Please Enter Subscription Date"),
      expiredat: Yup.string().required("Please Enter Expired Date"),
    }),
    onSubmit: (values) => {
      dispatch(getDisposalLoading());
      if (isEdit) {
        const updateDisposal = {
          id: disposal ? disposal.id : 0,
          disposal_name: values.disposal_name,
          subscribedat: values.subscribedat,
          expiredat: values.expiredat,
          description: values.description,
          statusId: values.status,
        };
        dispatch(onUpdateDisposal(updateDisposal));
        validation.resetForm();
      } else {
        const newDisposal = {
          disposal_name: values["disposal_name"],
          subscribedat: values["subscribedat"],
          expiredat: values["expiredat"],
          description: values["description"],
          statusId: values["status"],
        };
        dispatch(onAddNewDisposal(newDisposal));
        validation.resetForm();
      }
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteDisposal(element.value));
    });
    checkall.checked = false;
  };

  // able Column
  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            className="form-check-input"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="dataCheckbox form-check-input"
              value={cellProps.row.original.id} />
          );
        },
        id: "#",
      },
      {
        Header: "Nama",
        accessor: "disposal_name",
        filterable: true,
      },
      {
        Header: "Subscribe Date",
        accessor: "subscribedat",
        filterable: true,
        Cell: (disposal) => (
          <>
            {handleValidDate(disposal.row.original.subscribedat)},
            <small className="text-muted">

              {handleValidTime(disposal.row.original.subscribedat)}
            </small>
          </>
        ),
      },
      {
        Header: "Expired Date",
        accessor: "expiredat",
        filterable: true,
        Cell: (disposal) => (
          <>
            {handleValidDate(disposal.row.original.expiredat)},
            <small className="text-muted">

              {handleValidTime(disposal.row.original.expiredat)}
            </small>
          </>
        ),
      },
      {
        Header: "Status",
        accessor: "disposal_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}</span>
              );
            case "ACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-info">
                  {cell.value}</span>
              );
            case "INACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-danger">
                  {cell.value}</span>
              );
            default:
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}</span>
              );
          }
        },
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="apps-ecommerce-disposal-details"
                className="btn-icon btn btn-sm btn-light" >
                <i className="ri-eye-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={
                  userType === "admin"
                    ? "btn-icon btn btn-sm btn-light edit-item-btn"
                    : userRole && userRole.split(",").indexOf("updateDisposal") !== -1
                      ? "btn-icon btn btn-sm btn-light edit-item-btn"
                      : "btn-icon btn btn-sm btn-light edit-item-btn d-none"
                }
                onClick={() => {
                  const disposalData = cellProps.row.original;
                  handleDisposalClick(disposalData);
                }}>
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={
                  userType === "admin"
                    ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                    : userRole && userRole.split(",").indexOf("deleteDisposal") !== -1
                      ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                      : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"
                }
                onClick={() => {
                  const disposalData = cellProps.row.original;
                  onClickDelete(disposalData);
                }}>
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
    ],
    [handleDisposalClick, userType, userRole]
  );

  const defaultdate = () => {
    return moment().format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const [filterDate, setFilterDate] = useState(null);

  const handleSubscribedAt = (date) => {
    validation.setFieldValue("subscribedat", date);
  };

  const handleExpirededAt = (date) => {
    validation.setFieldValue("expiredat", date);
  };

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: disposalList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };
  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetDisposals(param));
  }

  document.title = "Disposals | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal
        show={isExportCSV}
        onCloseClick={() => setIsExportCSV(false)}
        data={disposalList} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteDisposal}
        onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Disposal" pageTitle="Companies" />
        <Row>
          <Col lg={12}>
            <Card id="disposalList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Disposal History &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={
                        userType === "admin"
                          ? "btn btn-primary add-btn me-2"
                          : userRole &&
                            userRole.split(",").indexOf("createDisposal") !== -1
                            ? "btn btn-primary add-btn me-2"
                            : "btn btn-primary add-btn me-2 d-none"
                      }
                      id="create-btn" onClick={() => {
                        setDisposal("");
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className="ri-building-line me-1 align-bottom fs-14"></i>    Tambah
                    </button>  <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i>    Export
                    </button>  <button
                      className={
                        userType === "admin"
                          ? "btn btn-soft-danger"
                          : userRole &&
                            userRole.split(",").indexOf("deleteDisposal") !== -1
                            ? "btn btn-soft-danger"
                            : "btn btn-soft-danger d-none"
                      }
                      onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>    Delete
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav
                    className="nav-tabs nav-tabs-custom nav-success"
                    role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "1" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"><i className="ri-building-line me-1 align-bottom fs-14"></i>      All Disposals
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "2" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"><i className="ri-information-line me-1 align-bottom fs-14"></i>      DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "3" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>      ACTIVE    </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "4" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"><i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>      INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select
                                className="form-select"
                                value={pageSize}
                                onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Select created date"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(obj, str) => {
                                  setFilterDate(str);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={4} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Select Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                                id="idStatus"></Select>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table
                      hover
                      {...getTableProps()}
                      className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr
                            className={""}
                            key={index}
                            {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                              <th
                                key={index}
                                className={"" + generateFilterable(column)}
                                {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="light"
                          onClick={previousPage}
                          disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Page    <strong>
                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input
                        type="number"
                        min={1}
                        style={{ width: 70 }}
                        max={pageOptions.length}
                        defaultValue={pageIndex + 1}
                        onChange={onChangeInInput}
                      />
                    </Col>

                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={nextPage}
                          disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal
                  id="showModal"
                  isOpen={modal}
                  centered
                  fullscreen={false}
                  size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Disposal" : "Add Disposal"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="mb-3">
                        <Label
                          htmlFor="disposalname-field"
                          className="form-label">
                          Disposal Name      </Label>
                        <Input
                          name="disposal_name"
                          id="disposalname-field"
                          className="form-control"
                          placeholder="Isi Nama"
                          type="text"
                          validate={{ required: { value: true } }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.disposal_name ?? ""}
                          invalid={
                            validation.touched.disposal_name &&
                              validation.errors.disposal_name
                              ? true
                              : false
                          } />
                        {validation.touched.disposal_name &&
                          validation.errors.disposal_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.disposal_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label htmlFor="date-field" className="form-label">
                          Subscribed Date
                        </Label>
                        <Flatpickr
                          name="date-picker"
                          className="form-control"
                          placeholder="Select subscribed date"
                          options={{
                            enableTime: true,
                            time_24hr: true,
                            dateFormat: "Y/m/d H:i",
                          }}
                          value={validation.values.subscribedat ?? ""}
                          onChange={(o, e) => {
                            handleSubscribedAt(e);
                          }} />
                        <Input
                          name="subscribedat"
                          id="subscribedat"
                          type="hidden"
                          validate={{ required: { value: true } }}
                          onChange={validation.handleChange}
                          invalid={
                            validation.touched.subscribedat &&
                              validation.errors.subscribedat
                              ? true
                              : false
                          } />
                        {validation.touched.subscribedat &&
                          validation.errors.subscribedat ? (
                          <FormFeedback type="invalid">
                            {validation.errors.subscribedat}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label htmlFor="date-field" className="form-label">
                          Expired Date
                        </Label>
                        <Flatpickr
                          name="date-picker2"
                          className="form-control"
                          placeholder="Select expired date"
                          options={{
                            enableTime: true,
                            time_24hr: true,
                            dateFormat: "Y/m/d H:i",
                          }}
                          value={validation.values.expiredat ?? ""}
                          onChange={(o, e) => {
                            handleExpirededAt(e);
                          }} />
                        <Input
                          name="expiredat"
                          id="expiredat"
                          type="hidden"
                          validate={{ required: { value: true } }}
                          onChange={validation.handleChange}
                          invalid={
                            validation.touched.expiredat &&
                              validation.errors.expiredat
                              ? true
                              : false
                          } />
                        {validation.touched.expiredat &&
                          validation.errors.expiredat ? (
                          <FormFeedback type="invalid">
                            {validation.errors.expiredat}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label htmlFor="active-status" className="form-label">
                          Status
                        </Label>
                        <Input
                          name="status"
                          type="select"
                          className="form-select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.status || "1"}>
                          {statusActiveData.map((item, key) => (
                            <React.Fragment key={key}>
                              {item.options.map((item, key) => (
                                <option value={item.value} key={key}>
                                  {item.label}
                                </option>
                              ))}
                            </React.Fragment>
                          ))}
                        </Input>
                      </div>

                      <div className="mb-3">
                        <Label htmlFor="des-field" className="form-label">
                          Description
                        </Label>
                        <Input
                          name="description"
                          id="disposalname-field"
                          className="form-control"
                          placeholder="Isi Keterangan"
                          type="textarea"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description ?? ""} />
                      </div>
                    </ModalBody>
                    <div className="modal-footer mb3">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}>
                          Cancel      </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">
                              {!!isEdit ? "Update" : "Add Disposal"}
                            </span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">Loading...</Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Disposal;
